import React from 'react';
import { Group, Panel, SimpleCell } from '@vkontakte/vkui';
import { Icon28ChevronRightOutline, Icon28SchoolOutline, Icon28StarsOutline } from '@vkontakte/icons';
import { AppShell, ScreenHeader } from '../../components/Layout/AppShell';
import { CABINET_PANEL } from '../../routing/routing';

export function CabinetPanel({ nav = CABINET_PANEL, onBack, openAchievements, openDictionary }) {
  return (
    <Panel nav={nav}>
      <ScreenHeader title="Мой кабинет" onBack={onBack} />
      <AppShell>
        <Group>
          <SimpleCell before={<Icon28StarsOutline />} after={<Icon28ChevronRightOutline />} onClick={openAchievements} expandable>
            Достижения
          </SimpleCell>
          <SimpleCell before={<Icon28SchoolOutline />} after={<Icon28ChevronRightOutline />} onClick={openDictionary} expandable>
            Словарь
          </SimpleCell>
        </Group>
      </AppShell>
    </Panel>
  );
}
